<template>
	<div>
		<hr>
		<div v-if="!isEmptyObject(meta)">
			<div class="form-group">
				<label for="title" class="font-weight-bold">Widget Label</label>
				<input type="text" class="form-control" v-model="meta.title" id="title"
					placeholder="Label yang akan ditampilkan di homepage">
			</div>
			<hr>
		</div>
		<div class="form-group">
			<label for="url">Title</label>
			<input type="text" class="form-control" v-model="config.title" id="url" placeholder="Input title for banner"
				required>
		</div>
		<div class="row">
			<div class="col-12 col-lg-6">
				<div class="form-group">
					<label for="url">First Link To</label>
					<input type="text" class="form-control" v-model="config.first_url" id="url"
						placeholder="Input url for first banner" required>
				</div>
			</div>
			<div class="col-12 col-lg-6">
				<div class="form-group">
					<label for="url">Second Link To</label>
					<input type="text" class="form-control" v-model="config.second_url" id="url"
						placeholder="Input url for second banner" required>
				</div>
			</div>
			<div class="col-12 col-lg-6">
				<div class="form-group">
					<label for="url">Third Link To</label>
					<input type="text" class="form-control" v-model="config.third_url" id="url"
						placeholder="Input url for third banner" required>
				</div>
			</div>
			<div class="col-12 col-lg-6">
				<div class="form-group">
					<label for="url">Fourth Link To</label>
					<input type="text" class="form-control" v-model="config.fourth_url" id="url"
						placeholder="Input url for fourth banner" required>
				</div>
			</div>
		</div>
		<div class="row">
			<!-- start upload first image area -->
			<div class="col-12 col-lg-6">
				<div class="form-group">
					<label for="image">First Image</label>
					<button class="btn btn-sm btn-plain text-danger"
						v-if="config.first_image_url !== undefined && config.first_image_url !== ''"
						@click="removeImage('first_image')">
						<i class="bi-x-circle"></i> Remove Image
					</button>
					<div class="my-2 text-center preview-image"
						v-if="config.first_image_url !== undefined && config.first_image_url !== ''">
						<img class="img-fluid rounded" :src="config.first_image_url" alt="Uploaded Image">
					</div>
					<div v-if="isFirstImageUploading && config.first_image_url === ''" class="pc-image-empty">
						<div class="image-loading">
							<div class="is-loading"></div>
						</div>
					</div>
					<div v-else-if="config.first_image_url === ''" class="pc-image-empty cursor-pointer"
						@click="uploadImage('first_image')">
						<div class="image-upload-placeholder">
							<i class="fi fi-rr-picture image-placeholder"></i>
							<div class="text-placeholder">
								Klik untuk upload.
							</div>
						</div>
					</div>
					<div class="pc-input-desc">
						Upload image dengan resolusi 1300x183px agar fit dengan ukuran banner.
					</div>
				</div>
			</div>
			<!-- start upload second image area -->
			<div class="col-12 col-lg-6">
				<div class="form-group">
					<label for="image">Second Image</label>
					<button class="btn btn-sm btn-plain text-danger"
						v-if="config.second_image_url !== undefined && config.second_image_url !== ''"
						@click="removeImage('second_image')">
						<i class="bi-x-circle"></i> Remove Image
					</button>
					<div class="my-2 text-center preview-image"
						v-if="config.second_image_url !== undefined && config.second_image_url !== ''">
						<img class="img-fluid rounded" :src="config.second_image_url" alt="Uploaded Image">
					</div>
					<div v-if="isSecondImageUploading && config.second_image_url === ''" class="pc-image-empty">
						<div class="image-loading">
							<div class="is-loading"></div>
						</div>
					</div>
					<div v-else-if="config.second_image_url === ''" class="pc-image-empty cursor-pointer"
						@click="uploadImage('second_image')">
						<div class="image-upload-placeholder">
							<i class="fi fi-rr-picture image-placeholder"></i>
							<div class="text-placeholder">
								Klik untuk upload.
							</div>
						</div>
					</div>
					<div class="pc-input-desc">
						Upload image dengan resolusi 1300x183px agar fit dengan ukuran banner.
					</div>
				</div>
			</div>
			<!-- start upload third image area -->
			<div class="col-12 col-lg-6">
				<div class="form-group">
					<label for="image">Third Image</label>
					<button class="btn btn-sm btn-plain text-danger"
						v-if="config.third_image_url !== undefined && config.third_image_url !== ''"
						@click="removeImage('third_image')">
						<i class="bi-x-circle"></i> Remove Image
					</button>
					<div class="my-2 text-center preview-image"
						v-if="config.third_image_url !== undefined && config.third_image_url !== ''">
						<img class="img-fluid rounded" :src="config.third_image_url" alt="Uploaded Image">
					</div>
					<div v-if="isThirdImageUploading && config.third_image_url === ''" class="pc-image-empty">
						<div class="image-loading">
							<div class="is-loading"></div>
						</div>
					</div>
					<div v-else-if="config.third_image_url === ''" class="pc-image-empty cursor-pointer"
						@click="uploadImage('third_image')">
						<div class="image-upload-placeholder">
							<i class="fi fi-rr-picture image-placeholder"></i>
							<div class="text-placeholder">
								Klik untuk upload.
							</div>
						</div>
					</div>
					<div class="pc-input-desc">
						Upload image dengan resolusi 1300x183px agar fit dengan ukuran banner.
					</div>
				</div>
			</div>
			<!-- start upload fourth image area -->
			<div class="col-12 col-lg-6">
				<div class="form-group">
					<label for="image">Fourth Image</label>
					<button class="btn btn-sm btn-plain text-danger"
						v-if="config.fourth_image_url !== undefined && config.fourth_image_url !== ''"
						@click="removeImage('fourth_image')">
						<i class="bi-x-circle"></i> Remove Image
					</button>
					<div class="my-2 text-center preview-image"
						v-if="config.fourth_image_url !== undefined && config.fourth_image_url !== ''">
						<img class="img-fluid rounded" :src="config.fourth_image_url" alt="Uploaded Image">
					</div>
					<div v-if="isFourthImageUploading && config.fourth_image_url === ''" class="pc-image-empty">
						<div class="image-loading">
							<div class="is-loading"></div>
						</div>
					</div>
					<div v-else-if="config.fourth_image_url === ''" class="pc-image-empty cursor-pointer"
						@click="uploadImage('fourth_image')">
						<div class="image-upload-placeholder">
							<i class="fi fi-rr-picture image-placeholder"></i>
							<div class="text-placeholder">
								Klik untuk upload.
							</div>
						</div>
					</div>
					<div class="pc-input-desc">
						Upload image dengan resolusi 1300x183px agar fit dengan ukuran banner.
					</div>
				</div>
			</div>
		</div>
		<!-- start upload mobile image -->
		<div class="row">
			<!-- start upload first image area -->
			<div class="col-12 col-lg-6">
				<div class="form-group">
					<label for="image">First Mobile Image</label>
					<button class="btn btn-sm btn-plain text-danger"
						v-if="config.first_mobile_image_url !== undefined && config.first_mobile_image_url !== ''"
						@click="removeImage('first_mobile_image')">
						<i class="bi-x-circle"></i> Remove Image
					</button>
					<div class="my-2 text-center preview-image"
						v-if="config.first_mobile_image_url !== undefined && config.first_mobile_image_url !== ''">
						<img class="img-fluid rounded" :src="config.first_mobile_image_url" alt="Uploaded Image">
					</div>
					<div v-if="isFirstMobileImageUploading && config.first_mobile_image_url === ''" class="pc-image-empty">
						<div class="image-loading">
							<div class="is-loading"></div>
						</div>
					</div>
					<div v-else-if="config.first_mobile_image_url === ''" class="pc-image-empty cursor-pointer"
						@click="uploadImage('first_mobile_image')">
						<div class="image-upload-placeholder">
							<i class="fi fi-rr-picture image-placeholder"></i>
							<div class="text-placeholder">
								Klik untuk upload.
							</div>
						</div>
					</div>
					<div class="pc-input-desc">
						Upload image dengan resolusi 640x640px agar fit dengan ukuran banner.
					</div>
				</div>
			</div>
			<!-- start upload second image area -->
			<div class="col-12 col-lg-6">
				<div class="form-group">
					<label for="image">Second Mobile Image</label>
					<button class="btn btn-sm btn-plain text-danger"
						v-if="config.second_mobile_image_url !== undefined && config.second_mobile_image_url !== ''"
						@click="removeImage('second_mobile_image')">
						<i class="bi-x-circle"></i> Remove Image
					</button>
					<div class="my-2 text-center preview-image"
						v-if="config.second_mobile_image_url !== undefined && config.second_mobile_image_url !== ''">
						<img class="img-fluid rounded" :src="config.second_mobile_image_url" alt="Uploaded Image">
					</div>
					<div v-if="isSecondMobileImageUploading && config.second_mobile_image_url === ''"
						class="pc-image-empty">
						<div class="image-loading">
							<div class="is-loading"></div>
						</div>
					</div>
					<div v-else-if="config.second_mobile_image_url === ''" class="pc-image-empty cursor-pointer"
						@click="uploadImage('second_mobile_image')">
						<div class="image-upload-placeholder">
							<i class="fi fi-rr-picture image-placeholder"></i>
							<div class="text-placeholder">
								Klik untuk upload.
							</div>
						</div>
					</div>
					<div class="pc-input-desc">
						Upload image dengan resolusi 640x640px agar fit dengan ukuran banner.
					</div>
				</div>
			</div>
			<!-- start upload third image area -->
			<div class="col-12 col-lg-6">
				<div class="form-group">
					<label for="image">Third Mobile Image</label>
					<button class="btn btn-sm btn-plain text-danger"
						v-if="config.third_mobile_image_url !== undefined && config.third_mobile_image_url !== ''"
						@click="removeImage('third_mobile_image')">
						<i class="bi-x-circle"></i> Remove Image
					</button>
					<div class="my-2 text-center preview-image"
						v-if="config.third_mobile_image_url !== undefined && config.third_mobile_image_url !== ''">
						<img class="img-fluid rounded" :src="config.third_mobile_image_url" alt="Uploaded Image">
					</div>
					<div v-if="isThirdMobileImageUploading && config.third_mobile_image_url === ''" class="pc-image-empty">
						<div class="image-loading">
							<div class="is-loading"></div>
						</div>
					</div>
					<div v-else-if="config.third_mobile_image_url === ''" class="pc-image-empty cursor-pointer"
						@click="uploadImage('third_mobile_image')">
						<div class="image-upload-placeholder">
							<i class="fi fi-rr-picture image-placeholder"></i>
							<div class="text-placeholder">
								Klik untuk upload.
							</div>
						</div>
					</div>
					<div class="pc-input-desc">
						Upload image dengan resolusi 640x640px agar fit dengan ukuran banner.
					</div>
				</div>
			</div>
			<!-- start upload fourth image area -->
			<div class="col-12 col-lg-6">
				<div class="form-group">
					<label for="image">Fourth Mobile Image</label>
					<button class="btn btn-sm btn-plain text-danger"
						v-if="config.fourth_mobile_image_url !== undefined && config.fourth_mobile_image_url !== ''"
						@click="removeImage('fourth_mobile_image')">
						<i class="bi-x-circle"></i> Remove Image
					</button>
					<div class="my-2 text-center preview-image"
						v-if="config.fourth_mobile_image_url !== undefined && config.fourth_mobile_image_url !== ''">
						<img class="img-fluid rounded" :src="config.fourth_mobile_image_url" alt="Uploaded Image">
					</div>
					<div v-if="isFourthMobileImageUploading && config.fourth_mobile_image_url === ''"
						class="pc-image-empty">
						<div class="image-loading">
							<div class="is-loading"></div>
						</div>
					</div>
					<div v-else-if="config.fourth_mobile_image_url === ''" class="pc-image-empty cursor-pointer"
						@click="uploadImage('fourth_mobile_image')">
						<div class="image-upload-placeholder">
							<i class="fi fi-rr-picture image-placeholder"></i>
							<div class="text-placeholder">
								Klik untuk upload.
							</div>
						</div>
					</div>
					<div class="pc-input-desc">
						Upload image dengan resolusi 640x640px agar fit dengan ukuran banner.
					</div>
				</div>
			</div>
		</div>
		<div class="form-group buttons m-0 hidden">
			<input type="file" accept="image/*" class="input-file" ref="imageUploader" id="pc-product-images-file"
				@change="onInputImageChange" multiple />
			<label for="pc-product-images-file" class="btn btn-primary" :class="{
				'is-loading': isImageUploading
			}">Upload images</label>
			<div class="pc-input-desc">
				Make sure your image resolution is 1296x324 px
			</div>
		</div>
		<!-- end upload image area -->
	</div>
</template>
<script>
import mediaApi from '@/api/media';
import { isEmptyObject } from '@/lib/helper';

export default {
	name: 'FourColumnBanner',
	props: {
		config: {
			type: Object,
			default: () => ({
				title: 'Four Column Banner',
				first_url: '',
				first_image_url: 'https://cdn.ostock.id/img/banner/inventro-banner-1.png',
				first_mobile_image_url: '',
				second_url: '',
				second_image_url: 'https://cdn.ostock.id/img/banner/inventro-banner-1.png',
				second_mobile_image_url: '',
				third_url: '',
				third_image_url: 'https://cdn.ostock.id/img/banner/inventro-banner-1.png',
				third_mobile_image_url: '',
				fourth_url: '',
				fourth_image_url: 'https://cdn.ostock.id/img/banner/inventro-banner-1.png',
				fourth_mobile_image_url: '',
			}),
		},
		meta: {},
	},
	data() {
		return {
			isFirstImageUploading: false,
			isFirstMobileImageUploading: false,
			isSecondImageUploading: false,
			isSecondMobileImageUploading: false,
			isThirdImageUploading: false,
			isThirdMobileImageUploading: false,
			isFourthImageUploading: false,
			isFourthMobileImageUploading: false,
			stateUpload: 'first_image',
		};
	},
	methods: {
		isEmptyObject,
		removeImage(state) {
			this.updateStateUpload(false, '', state);
		},
		uploadImage(state) {
			this.stateUpload = state;
			const inputFile = this.$refs.imageUploader;
			inputFile.click();
		},
		updateStateUpload(isUploading = true, url = '', state = this.stateUpload) {
			switch (state) {
			case 'first_image':
				this.isFirstImageUploading = isUploading;
				this.$set(this.config, 'first_image_url', url);
				break;
			case 'second_image':
				this.isSecondImageUploading = isUploading;
				this.$set(this.config, 'second_image_url', url);
				break;
			case 'third_image':
				this.isThirdImageUploading = isUploading;
				this.$set(this.config, 'third_image_url', url);
				break;
			case 'fourth_image':
				this.isFourthImageUploading = isUploading;
				this.$set(this.config, 'fourth_image_url', url);
				break;
			case 'first_mobile_image':
				this.isFirstMobileImageUploading = isUploading;
				this.$set(this.config, 'first_mobile_image_url', url);
				break;
			case 'second_mobile_image':
				this.isSecondMobileImageUploading = isUploading;
				this.$set(this.config, 'second_mobile_image_url', url);
				break;
			case 'third_mobile_image':
				this.isThirdMobileImageUploading = isUploading;
				this.$set(this.config, 'third_mobile_image_url', url);
				break;
			case 'fourth_mobile_image':
				this.isFourthMobileImageUploading = isUploading;
				this.$set(this.config, 'fourth_mobile_image_url', url);
				break;
			default:
				this.isFirstImageUploading = isUploading;
				this.$set(this.config, 'first_image_url', url);
				break;
			}
		},
		onInputImageChange(event) {
			this.updateStateUpload(true, '');

			const maxUploadSize = 3; // MB
			const input = event.target;
			for (let i = 0; i < input.files.length; i++) {
				const image = input.files[i];

				// Check File Size
				let fileSize = image.size;
				fileSize /= 1048576;

				const isFileSizeTooLarge = fileSize > maxUploadSize;

				// Show Notice if size too large
				if (isFileSizeTooLarge) {
					const noticeMessage = `'${image.name}' size is too large (max 3MB)`;
					this.$notify({
						group: 'admin-sliders',
						text: noticeMessage,
						type: 'warn',
					});
					break;
				}

				// Start Upload
				const uploadParams = new FormData();
				uploadParams.append('image', image);

				const callback = (response) => {
					this.isUploading = false;
					const path = response.data;
					const url = `${this.mediaUrlPrefix}/${path}`;

					this.updateStateUpload(false, url);
				};

				const errorCallback = (e) => {
					this.updateStateUpload(false, '');
					console.log(e);
				};

				// Upload Image
				mediaApi.uploadImage(uploadParams, callback, errorCallback);
			}
			event.target.files = null;
			event.target.value = '';
		},
	},
	computed: {
		isImageUploading() {
			return this.isFirstImageUploading
				|| this.isSecondImageUploading
				|| this.isThirdImageUploading
				|| this.isFourthImageUploading
				|| this.isFirstMobileImageUploading
				|| this.isSecondMobileImageUploading
				|| this.isThirdMobileImageUploading
				|| this.isFourthMobileImageUploading;
		},
	},
};
</script>
<style lang="scss" scoped>
label {
	font-weight: 700;
	font-size: 16px;
	line-height: 150%;
}

.form-control {
	border: 2px solid #1F1F1F61;
	height: calc(2.3em + 0.75rem + 2px);
}

.single-banner {
	img {
		border-radius: 16px;
	}
}
</style>
